import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const ADD_REPORT_PACKAGE_FAVORITE = "ADD_REPORT_PACKAGE_FAVORITE";

export const service = async (data) => {
  const options: object = {
    url: `/api/ReportPackage/SaveReportPackageFavorite`,
    method: "POST",
     ...getDefaultOptions(),
    body: JSON.stringify(data)
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(ADD_REPORT_PACKAGE_FAVORITE, service, mock);
